<template>
  <div class="w-100 h-100">
    <div class="d-flex justify-content-between align-items-end">
      <label v-if="title" class="graph__label">{{ title }}</label>
      <label v-if="subTitle" class="graph-sub__label">{{ subTitle }}</label>
    </div>
    <b-progress
      :value="value"
      :max="max"
      :variant="color"
      class="rounded-pill"
    ></b-progress>
  </div>
</template>

<script>
import { BProgress } from "bootstrap-vue"
export default {
  name: "AtomBootstrapProgressBar",
  components: {
    BProgress,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: "",
    },
    subTitle: {
      type: String,
      required: false,
      default: "",
    },
    color: {
      type: String,
      required: false,
      default: "primary",
      // value = [ "primary", "warning", "danger"]
    },
    value: {
      type: Number,
      required: true,
    },
    max: {
      type: Number,
      required: false,
      default: 100,
    },
  },
  data() {
    return {
      option: {},
    }
  },
  methods: {
    toPercentage(value, max) {
      return Math.round((value / max) * 100)
    },
  },
}
</script>

<style lang="scss" scoped>
.full {
  height: 100%;
  width: 100%;
}
.graph__label {
  color: #6e6b7b;
  font-size: 14px;
}

.graph-sub__label {
  color: #5E5873;
  font-weight: 500;
  font-size: 12px;
}
</style>
